import { render, staticRenderFns } from "./VerifyDomainForm.vue?vue&type=template&id=175a711c"
import script from "./VerifyDomainForm.vue?vue&type=script&lang=js"
export * from "./VerifyDomainForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports